/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditornosections3Inputs */

const en_menueditornosections3 = /** @type {(inputs: Menueditornosections3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No sections yet.`)
};

const de_menueditornosections3 = /** @type {(inputs: Menueditornosections3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bereiche.`)
};

/**
* | output |
* | --- |
* | "No sections yet." |
*
* @param {Menueditornosections3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditornosections3 = /** @type {((inputs?: Menueditornosections3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditornosections3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditornosections3(inputs)
	return de_menueditornosections3(inputs)
});
export { menueditornosections3 as "menuEditorNoSections" }